module.exports = __webpack_public_path__ + "static/media/ago_luberg.791d230d.jpg";